import React, { Component } from "react";
import { compose, withState, withActions } from "containers/HOC";
import { withRouter } from "react-router-dom";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import Details from "./Details";
import { submitIrrigation } from "./_actions";
import * as utils from "common/utils";
import { modalInlineClose, modalInlineOpen } from "containers/App/_actions";
import { getCompositions } from "../../Custom/_actions";

class IrrigationEdit extends Component {
    componentDidMount() {
        this.props.getCompositions();
    }
    render() {
        const { farm, irrigatorBudget } = this.props;
        return (
            <Tile>
                <PageTabs farmId={farm.id} budget={irrigatorBudget} tab={TAB.IRRIGATION} />
                <TileBody>
                    <Details online={this.props.online} refData={this.props.refData} farm={farm} budget={irrigatorBudget} irrigator={this.props.irrigator} submit={this.props.submitIrrigation} isNew={false} modalInlineClose={this.props.modalInlineClose} modalInlineOpen={this.props.modalInlineOpen} customCompositions={this.props.customCompositions} />
                </TileBody>
            </Tile>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        const irrigatorId = ownProps.match.params.irrigatorId;
        const budget = utils.clone(ownProps.budget);
        const irrigator = budget ? budget.irrigators.find((i) => i.id === irrigatorId) : null;
        const { customNutrients = {} } = state;
        const { nutrientCompositions = [] } = customNutrients;
        return {
            ...ownProps,
            refData: state.app.refData,
            irrigator: irrigator,
            irrigatorBudget: budget,
            irrigatorId: irrigatorId,
            customCompositions: utils.clone(nutrientCompositions.filter((c) => c.type === "Irrigation")),
        };
    }),
    withActions({ submitIrrigation, modalInlineClose, modalInlineOpen, getCompositions })
)(IrrigationEdit);
